// include stuff to add / remove / shuffle VariableFieldconfigurators

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Badge, Button, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  EdgeType,
  TemplateFieldV2,
} from "../../../../docuclipper/DocuclipperTypes";
import { withTooltip } from "../../../../hoc/withTooltip";
import {
  addVariableField,
  deleteVariableField,
  duplicateVariableField,
  fetchEdgesFromWords,
  fetchExtractedData,
  setCanvasMode,
  setDragMode,
  setSelectedEdge,
  setVariableSelectedId,
  updateEdgePercentage,
  updateEdgePercentageDisable,
  updateIncludeWords,
  updateVlOffset,
  wordsSetWords,
} from "../../../../redux/reducers/TemplateField";
import VariableField from "./VariableField";
import { withSelectedField } from "./withSelectedField";

const ButtonWithTT = withTooltip(Button);

type Props = { field: TemplateFieldV2 };

export const _VariableFields: React.SFC<Props> = ({ field }) => {
  const dispatch = useDispatch();
  if (field.locationType === "fixed" || !field.variableLocation) {
    return null;
  }
  return (
    <>
      {field.variableLocation &&
        field.variableLocation.variableLocations
          // .sort((a, b) => a.order - b.order)
          .map((vl, i) => (
            <div key={i} className="mb-2">
              <Row className="justify-content-end">
                {vl.id === field.variableLocation?.selectedId && (
                  <div>
                    <Badge variant="primary" className="mr-2">
                      Active
                    </Badge>
                  </div>
                )}
                <ButtonWithTT
                  variant="secondary"
                  size="sm"
                  placement="bottom"
                  id={`duplicateVl${i}`}
                  renderTooltip={() => (
                    <span>Duplicate Variable Configuration</span>
                  )}
                  onClick={() =>
                    dispatch(
                      duplicateVariableField({
                        id: field.id,
                        vlId: vl.id,
                      })
                    )
                  }
                >
                  <FontAwesomeIcon icon="copy" />
                </ButtonWithTT>
                <ButtonWithTT
                  variant="secondary"
                  className="ml-1"
                  size="sm"
                  placement="bottom"
                  id={`deleteVl${i}`}
                  renderTooltip={() => (
                    <span>Delete Variable Configuration</span>
                  )}
                  onClick={() =>
                    dispatch(
                      deleteVariableField({
                        id: field.id,
                        vlId: vl.id,
                      })
                    )
                  }
                >
                  <FontAwesomeIcon icon="trash" />
                </ButtonWithTT>
              </Row>
              <VariableField
                onSetPercentage={(edgeType: EdgeType) => {
                  // dispatch(setCanvasMode({ canvasMode: "edges" }));
                  // dispatch(setSelectedEdge({ selectedEdge: edgeType }));
                }}
                onSetWords={(edgeType: EdgeType) => {
                  dispatch(setCanvasMode({ canvasMode: "selectWords" }));
                  dispatch(setSelectedEdge({ selectedEdge: edgeType }));
                  dispatch(setDragMode({ dragModeEnabled: false }));
                  dispatch(
                    setVariableSelectedId({ id: field.id, vlId: vl.id })
                  );
                }}
                variableLocationEdges={vl}
                onWordsChanged={(edgeType: EdgeType, words: string[]) => {
                  dispatch(
                    setVariableSelectedId({ id: field.id, vlId: vl.id })
                  );
                  dispatch(
                    wordsSetWords({
                      edge: edgeType,
                      words,
                      id: field.id,
                      vlId: vl.id,
                    })
                  );
                  dispatch(fetchExtractedData({ id: field.id }));
                  // dispatch(fetchWords({

                  // }));
                  dispatch(
                    fetchEdgesFromWords({
                      id: field.id,
                      edge: edgeType,
                      // vlId: vl.id,
                    })
                  );
                }}
                enablePercentage={(edgeType: EdgeType) => {
                  dispatch(
                    setVariableSelectedId({ id: field.id, vlId: vl.id })
                  );
                  dispatch(
                    updateEdgePercentage({
                      edge: edgeType,
                      id: field.id,
                      vlId: vl.id,
                    })
                  );
                  dispatch(fetchExtractedData({ id: field.id }));
                }}
                disablePercentage={(edgeType: EdgeType) => {
                  dispatch(
                    setVariableSelectedId({ id: field.id, vlId: vl.id })
                  );
                  dispatch(
                    updateEdgePercentageDisable({
                      edge: edgeType,
                      id: field.id,
                      vlId: vl.id,
                    })
                  );
                  dispatch(fetchExtractedData({ id: field.id }));
                }}
                updateIncludeWords={(edgeType: EdgeType, checked: boolean) => {
                  dispatch(
                    setVariableSelectedId({ id: field.id, vlId: vl.id })
                  );
                  dispatch(
                    updateIncludeWords({
                      edgeType,
                      checked,
                      vlId: vl.id,
                    })
                  );
                  dispatch(
                    fetchEdgesFromWords({
                      id: field.id,
                      edge: edgeType,
                      vlId: vl.id,
                    })
                  );
                  dispatch(fetchExtractedData({ id: field.id }));
                }}
                onOffsetChange={(edgeType: EdgeType, offset: number) => {
                  dispatch(
                    updateVlOffset({
                      edgeType,
                      offset,
                      id: field.id,
                      vlId: vl.id,
                    })
                  );
                  dispatch(
                    fetchEdgesFromWords({
                      id: field.id,
                      edge: edgeType,
                      vlId: vl.id,
                    })
                  );
                  dispatch(fetchExtractedData({ id: field.id }));
                }}
              />
            </div>
          ))}
      <Row>
        <Button
          variant="link"
          onClick={() =>
            dispatch(
              addVariableField({
                id: field.id,
              })
            )
          }
        >
          <FontAwesomeIcon icon="plus" />
          <span className="ml-1">Add Variable Configuration</span>
        </Button>
      </Row>
    </>
  );
};

export const VariableFields = withSelectedField(_VariableFields);
